import { FiDialogsService } from '@fi-shared/fi-dialogs';
import { Injectable } from '@angular/core';
import { MatDialogConfig } from '@angular/material/dialog';
import { MediaViewerComponent } from './media-viewer.component';
import { FileType } from '@fi-shared/types';
import { IMediaBankFile, IMediaBankFileReference } from '@fi-shared/media-bank';
import { IImagePreviewData } from '@fi-shared/media-bank/media-bank';
import { Subject } from 'rxjs';
import { IVideoProgressEvent } from '@fi-shared/media-bank/fi-vimeo/fi-vimeo-player-api';

@Injectable()
export class MediaViewerService {
    private dialogConfig: MatDialogConfig = {
        minWidth: '300px',
        maxWidth: '95%',
        maxHeight: 'unset',
        panelClass: 'media-viewer-panel',
    };

    constructor(private fiDialogsService: FiDialogsService) {}

    Show(
        image: string,
        mediaBankFiles: IMediaBankFile[],
        mediaBankFileReferences: IMediaBankFileReference[],
        videoProgressListener$?: Subject<IVideoProgressEvent>,
        skipStatisticsSave?: boolean,
    ) {
        const dialogContentData: IImagePreviewData = {
            url: image,
            mediaBankFiles,
            mediaBankFileReferences,
            fileType: FileType.Image,
            videoProgressListener$,
            skipStatisticsSave,
        };
        this.openMediaViewer(dialogContentData, {
            maxWidth: '100vw',
            maxHeight: '100vh',
            panelClass: [this.dialogConfig.panelClass, 'full-size'],
            autoFocus: false,
        });
    }

    ShowVideoPopup(
        href: string,
        mediaBankFile?: IMediaBankFile,
        mediaBankFileReference?: IMediaBankFileReference,
        videoProgressListener$?: Subject<IVideoProgressEvent>,
    ) {
        const dialogContentData: IImagePreviewData = {
            url: href,
            mediaBankFiles: [mediaBankFile],
            mediaBankFileReferences: [mediaBankFileReference],
            fileType: FileType.Movie,
            videoProgressListener$,
        };
        this.openMediaViewer(dialogContentData);
    }

    private openMediaViewer(contentData: IImagePreviewData, dialogConfig?) {
        this.fiDialogsService.custom({
            hideHeader: true,
            hideFooter: true,
            hideDialogTopBorder: true,
            contentComponentRef: MediaViewerComponent,
            contentComponentData: contentData,
            config: dialogConfig ? dialogConfig : this.dialogConfig,
        });
    }
}
